import { TaskList } from "../../Types/state/masterdata";

export interface IState {
  tasks: TaskList[];
  tasksCount: number;
}

type Action = any;

export const tasksReducer = (
  state: IState = {
    tasks: [],
    tasksCount: 0,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_TASKS":
      return {
        ...state,
        tasks: action?.payload?.page == 1 ? action?.payload?.data : [...state?.tasks, ...action?.payload?.data],
        tasksCount: action?.payload?.count,
      };
    case "UPDATE_TASKS":
      return {
        ...state,
        tasks: state?.tasks?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_TASKS":
      return {
        ...state,
        tasks: state?.tasks?.filter((elem: any) => elem?._id !== action?.payload),
      };
    default:
      return state;
  }
};
